/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/jsx-filename-extension */
import React, { useRef, useCallback, useMemo } from 'react';
import { MessageBox, Icon } from '@ui5/webcomponents-react';
import '@ui5/webcomponents-icons/dist/sys-help-2';
import eurekaMgrs from '@eureka/ui-managers';
import EurekaComponents from 'eureka';

const { useTranslation } = EurekaComponents.I18nProvider;
const { getConfig } = eurekaMgrs.ConfigManager;

export default ({ open, onClose }) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const { auth_provider, auth_method } = getConfig('user') || {};

  const actions = useMemo(() => ({
    [t('Header_Logout_Btn_Yes')]: () => {
      if (formRef.current) {
        onClose();
        formRef.current.submit();
      }
    },
    [t('Cancel')]: () => {
      onClose();
    },
  }), [t, onClose]);

  const handleClose = useCallback(
    (e) => {
      const action = e.detail.action;
      if (action && actions[action]) {
        actions[action]();
      } else {
        onClose();
      }
    },
    [actions, onClose],
  );

  return (
    <>
      <form ref={formRef} action="/auth/logout" method="post" style={{ display: 'none' }}>
        <input type="hidden" name="auth_provider" value={auth_provider} />
        <input type="hidden" name="auth_method" value={auth_method} />
      </form>
      {open && (
        <MessageBox
          open
          icon={<Icon name="sys-help-2" />}
          titleText={t('Header_Confirmation')}
          onClose={handleClose}
          actions={Object.keys(actions)}
          emphasizedAction=""
          data-testid="logout-message-box"
        >
          {t('Header_Logout_Confirmation')}
        </MessageBox>
      )}
    </>
  );
};
